import DropdownSelect from '@/shared/ui/DropdownSelect/DropdownSelect';
import type { DropdownSelectProps } from '@/shared/ui/DropdownSelect/DropdownSelect';
import { useIsAiBusy } from '@/features/chats/stores';

/**
 * A wrapper around DropdownSelect that automatically disables the dropdown
 * when the LLM is generating a response. This prevents users from changing
 * agent options mid-generation.
 */
export const ChatOptionDropdown = <T extends string | number>(props: DropdownSelectProps<T>) => {
  const isAiBusy = useIsAiBusy();

  return <DropdownSelect {...props} disabled={isAiBusy || props.disabled} />;
};
